import { getAbsoluteSiteBase } from './publicBase';

export const HOME_PAGE_TITLE =
	'NBFC Loans: LAS, Loan Against Shares & Mutual Funds (LAMF) | AngelOne Fincap';

export const HOME_META_DESCRIPTION =
	'RBI-registered NBFC offering secured loans: LAS (loan against securities), loans against stocks, shares, ETFs and equity, loan against portfolio—and loans against mutual funds (LAMF). Borrow without selling your investments.';

/** Supplemental terms; use together with strong titles and visible copy. */
export const HOME_META_KEYWORDS = [
	'loan against security',
	'loan against securities',
	'loan against shares',
	'loans against stocks',
	'LAS',
	'loans',
	'udhaar',
	'borrow',
	'karza',
	'lend',
	'loans against mutual funds',
	'LAMF',
	'loan',
	'secured loan',
	'loan against stocks',
	'loan against portfolio',
	'loan against ETF',
	'loan against equity',
	'equity loan',
	'stocks loan'
].join(', ');

type FaqItem = { title: string; body: string };

export function buildHomeJsonLd(faqItems: FaqItem[]): Record<string, unknown> {
	const base = getAbsoluteSiteBase();
	const logoPath = '/images/ao_fincap_logo.svg';
	const logoUrl = base ? `${base}${logoPath}` : logoPath;

	return {
		'@context': 'https://schema.org',
		'@graph': [
			{
				'@type': 'Organization',
				name: 'AngelOne Fincap Private Limited',
				legalName: 'AngelOne Fincap Private Limited',
				url: base ?? undefined,
				logo: logoUrl,
				description:
					'Non-Banking Financial Company (NBFC) registered with the Reserve Bank of India, offering loan against securities (LAS), loans against stocks and ETFs, and loans against mutual funds (LAMF).'
			},
			{
				'@type': 'WebSite',
				name: 'AngelOne Fincap',
				url: base ?? undefined,
				description: HOME_META_DESCRIPTION
			},
			{
				'@type': 'FAQPage',
				mainEntity: faqItems.map((item) => ({
					'@type': 'Question',
					name: item.title,
					acceptedAnswer: {
						'@type': 'Answer',
						text: item.body
					}
				}))
			}
		]
	};
}

function escapeJsonForHtml(json: string): string {
	return json.replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026');
}

export function homeJsonLdScriptContent(faqItems: FaqItem[]): string {
	return escapeJsonForHtml(JSON.stringify(buildHomeJsonLd(faqItems)));
}
